export default {
	'custom-actual-size': {
		width: 63.414,
		height: 63.414,
		/* eslint-disable max-len */
		raw: '<polygon points="1.414,63.414 21.707,43.121 21.707,51.707 23.707,51.707 23.707,40.707 22.707,39.707 11.707,39.707 11.707,41.707 20.293,41.707 0,62 		"/><polygon points="39.707,51.707 41.707,51.707 41.707,43.121 62,63.414 63.414,62 43.121,41.707 51.707,41.707 51.707,39.707 40.707,39.707 39.707,40.707 		"/> <polygon points="39.707,11.707 39.707,22.707 40.707,23.707 51.707,23.707 51.707,21.707 43.121,21.707 63.414,1.414 62,0 41.707,20.293 41.707,11.707 		"/><polygon points="11.707,23.707 22.707,23.707 23.707,22.707 23.707,11.707 21.707,11.707 21.707,20.293 1.414,0 0,1.414 20.293,21.707 11.707,21.707 		"/>'
	}
};
